function normalizeBaseUrl(baseUrl) {
  return (baseUrl || '').replace(/\/$/, '');
}

function isAbsoluteUrl(url) {
  return /^https?:\/\//i.test(url);
}

function normalizeHostname(value) {
  if (!value) {
    return '';
  }

  const trimmed = String(value).trim().replace(/\.$/, '');
  if (!trimmed) {
    return '';
  }

  try {
    if (/^https?:\/\//i.test(trimmed)) {
      return new URL(trimmed).hostname.toLowerCase();
    }
  } catch {
    // Ignore malformed URLs and fall back to text normalization.
  }

  const colonCount = (trimmed.match(/:/g) || []).length;
  if (colonCount === 1 && !trimmed.startsWith('[')) {
    return trimmed.split(':')[0].toLowerCase();
  }

  return trimmed.toLowerCase();
}

function resolveCallbackToken(config) {
  return config.callbackToken || config.xCallbackToken || '';
}

function resolveClientHostname(config) {
  return normalizeHostname(config.clientHostname || (typeof window !== 'undefined' && window.location ? window.location.hostname : ''));
}

function buildDefaultHeaders(config) {
  const headers = {};
  const clientId = config.clientId || '';
  const callbackToken = resolveCallbackToken(config);
  const clientHostname = resolveClientHostname(config);

  if (clientId) {
    headers['x-client-id'] = clientId;
  }

  if (clientHostname) {
    headers['x-client-hostname'] = clientHostname;
  }

  if (callbackToken) {
    headers['x-callback-token'] = callbackToken;
  }

  return headers;
}

export function createBaseApiClient(config, configuredBaseUrl) {
  const baseUrl = normalizeBaseUrl(configuredBaseUrl || '');
  const defaultHeaders = buildDefaultHeaders(config);

  async function request(path, options = {}) {
    const isAbsolute = isAbsoluteUrl(path);
    const url = isAbsolute ? path : `${baseUrl}${path}`;

    const mergedHeaders = {
      ...defaultHeaders,
      ...(options.headers || {})
    };

    const response = await fetch(url, {
      ...options,
      headers: mergedHeaders
    });

    return response;
  }

  async function get(path, headers = {}) {
    return request(path, {
      method: 'GET',
      headers
    });
  }

  async function post(path, body, headers = {}) {
    return request(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      body: JSON.stringify(body)
    });
  }

  async function put(path, body, headers = {}) {
    return request(path, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      body: JSON.stringify(body)
    });
  }

  async function deleteRequest(path, body, headers = {}) {
    const requestOptions = {
      method: 'DELETE',
      headers: {
        ...headers
      }
    };

    if (body !== undefined) {
      requestOptions.headers['Content-Type'] = 'application/json';
      requestOptions.body = JSON.stringify(body);
    }

    return request(path, requestOptions);
  }

  return {
    get,
    post,
    put,
    delete: deleteRequest,
    request,
    baseUrl,
    defaultHeaders
  };
}

export function createMusClient(config) {
  return createBaseApiClient(config, config.uploadS3ApiBaseUrl || '');
}
